import bannerImage from '../../static/banner.png';
import bannerImageMobile from '../../static/banner_mobile.png';

import LandingPageCategories from './LandingPageCategories';

import styles from './LandingPage.module.scss';

const LandingPage = () => {
  return (
    <>
      <div className={styles.Banner}>
        <div className={styles.ImageContainer}>
          <picture>
            <source media="(max-width: 400px)" srcSet={bannerImageMobile} />
            <source media="(min-width: 401px)" srcSet={bannerImage} />
            <img src={bannerImage} alt="landing graphics" className={styles.Image} />
          </picture>
          <div className={styles.Intro}>
            <div className={styles.Title}>Web Tools and Services</div>
            <div className={styles.Paragraph}>
              Find applications and services suitable for your use case.
            </div>
          </div>
        </div>
      </div>
      <LandingPageCategories />
    </>
  );
};

export default LandingPage;
